export const FETCH_TARGETS = 'FETCH_TARGETS';
export const FETCH_TARGETS_START = 'FETCH_TARGETS_START';
export const FETCH_TARGETS_SUCCESS = 'FETCH_TARGETS_SUCCESS';
export const FETCH_TARGETS_FAIL = 'FETCH_TARGETS_FAIL';


